import { REMOVE_EXCHANGE_PENDING } from "../../types";

export const removeExchangePending = () => ({
  type: REMOVE_EXCHANGE_PENDING,
});
